import { ISort } from "../PatientList/components/UTable/table"
interface ITableConfig {
  columndef: { [key: string]: unknown }[]
  defaultSort: ISort
  tableData?: any //Temporary
  title: string
}

export const CASE_OVERVIEW_TABLE: ITableConfig = {
  title: "caseOverviewTitle",
  columndef: [
    {
      name: "Plan",
      id: "casePlan",
      dataKey: "casePlan",
      cell: {
        style: {
          fontWeight: "bold !important",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: 260,
        },
      },
      visible: true,
    },
    {
      name: "Remaining Aligners To Order",
      id: "alignersToOrder",
      dataKey: "alignersToOrder",
      cell: {
        style: {
          fontWeight: "bold !important",
          width: 264,
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
    {
      name: "Created",
      id: "createDate",
      dataKey: "createDate",
      cell: {
        style: {
          fontWeight: "bold !important",
          width: 140,
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
    {
      name: "Category",
      id: "category",
      dataKey: "category",
      cell: {
        style: {
          fontWeight: "bold !important",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: 140,
        },
      },
      visible: true,
    },
    {
      name: "Case Status",
      id: "caseStatus",
      dataKey: "caseStatus",
      cell: {
        style: {
          fontWeight: "bold !important",
          width: 200,
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
    {
      name: "Workflow",
      id: "phase",
      dataKey: "phase",
      cell: {
        style: {
          fontWeight: "bold !important",
          width: 200,
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
  ],
  defaultSort: { direction: "desc", key: "created" } as {
    key: string
    direction: "asc" | "desc"
  },
}

export const BUNDLE_OVERVIEW_TABLE: ITableConfig = {
  title: "bundlesOverviewTitle",
  columndef: [
    {
      name: "Bundle Type",
      id: "bundleType",
      dataKey: "bundleType",
      cell: {
        style: {
          fontWeight: "bold !important",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: 260,
        },
      },
      visible: true,
    },
    {
      name: "Remaining Bundle Allotment",
      id: "remainingBundleAllotment",
      dataKey: "remainingBundleAllotment",
      cell: {
        style: {
          fontWeight: "bold !important",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: 264,
        },
      },
      visible: true,
    },
    {
      name: "Purchased",
      id: "purchaseDate",
      dataKey: "purchaseDate",
      cell: {
        style: {
          fontWeight: "bold !important",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: 140,
        },
      },
      visible: true,
    },
    {
      name: "Expires",
      id: "expiryDate",
      dataKey: "expiryDate",
      cell: {
        style: {
          fontWeight: "bold !important",
          textOverflow: "ellipsis",
          overflow: "hidden",
        },
      },
      visible: true,
    },
  ],
  defaultSort: { direction: "desc", key: "purchaseDate" } as {
    key: string
    direction: "asc" | "desc"
  },
}

// Common cell style for all columns
const commonCellStyle = {
  fontWeight: "bold !important",
  textOverflow: "ellipsis",
  overflow: "hidden",
}

// Common column definitions
const commonColumns = {
  treatmentPlan: {
    name: "Treatment Plan",
    id: "treatmentPlan",
    dataKey: "treatmentPlan",
    cell: {
      style: {
        ...commonCellStyle,
        width: 260,
      },
    },
    visible: true,
  },
  shippingAddress: {
    name: "Shipping Address",
    id: "shippingAddress",
    dataKey: "businessName",
    cell: {
      style: {
        ...commonCellStyle,
        width: 260,
      },
    },
    visible: true,
  },
  type: (name: string) => ({
    name,
    id: "orderType",
    dataKey: "orderType",
    cell: {
      style: {
        ...commonCellStyle,
        width: 140,
      },
    },
    visible: true,
  }),
  date: (name: string) => ({
    name,
    id: "orderDate",
    dataKey: "orderDate",
    cell: {
      style: {
        ...commonCellStyle,
        width: 140,
      },
    },
    visible: true,
  }),
  status: {
    name: "Status",
    id: "orderStatus",
    dataKey: "orderStatus",
    cell: {
      style: {
        ...commonCellStyle,
        width: 200,
      },
    },
    visible: true,
  },
  order: (name: string) => ({
    name,
    id: "order",
    dataKey: "order",
    cell: {
      style: {
        ...commonCellStyle,
        width: 264,
      },
    },
    visible: true,
  }),
}

// Common default sort configuration
const defaultSortConfig = {
  direction: "desc",
  key: "orderDate",
} as {
  key: string
  direction: "asc" | "desc"
}

export const ORDER_OVERVIEW_TABLE: ITableConfig = {
  title: "ordersOverviewTitle",
  columndef: [
    commonColumns.treatmentPlan,
    commonColumns.order("Order"),
    commonColumns.shippingAddress,
    commonColumns.type("Order Type"),
    commonColumns.date("Order Date"),
    commonColumns.status,
    {
      name: "Order #",
      id: "orderNumber",
      dataKey: "orderNumber",
      cell: {
        style: commonCellStyle,
      },
      visible: true,
    },
  ],
  defaultSort: defaultSortConfig,
}

export const PRINT_OVERVIEW_TABLE: ITableConfig = {
  title: "printOverviewTitle",
  columndef: [
    commonColumns.treatmentPlan,
    commonColumns.order("Print"),
    commonColumns.type("Print Type"),
    commonColumns.date("Print Date"),
    commonColumns.status,
  ],
  defaultSort: defaultSortConfig,
}
